import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { LegalService } from '@services';
import { ButtonModule } from 'primeng/button';

interface Policy {
    name: string;
    url: string;
}

@Component({
    selector: 'app-legal-urls',
    imports: [ButtonModule],
    templateUrl: './legal-urls.component.html',
    styleUrl: './legal-urls.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LegalUrlsComponent {
    protected readonly policies: Policy[];

    private readonly policyInfoService = inject(LegalService);

    constructor() {
        this.policies = [
            {
                name: 'Privacy Policy',
                url: this.policyInfoService.url.pp
            },
            {
                name: 'Terms Of Service',
                url: this.policyInfoService.url.tos
            },
            {
                name: 'Acceptable Use Policy',
                url: this.policyInfoService.url.aup
            }
        ];
    }
}
